const SUMMARY_FETCH = 'bfb/summary/SUMMARY_FETCH';
const SUMMARY_FETCH_SUCCEEDED = 'bfb/summary/SUMMARY_FETCH_SUCCEEDED';
const SUMMARY_FETCH_FAILED = 'bfb/summary/SUMMARY_FETCH_FAILED';

export default {
  SUMMARY_FETCH,
  SUMMARY_FETCH_SUCCEEDED,
  SUMMARY_FETCH_FAILED,
};
